var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home min-vh-75"},[_c('div',{staticClass:"dashboard h-100"},[_c('dashboard',{staticClass:"h-100",attrs:{"readonly":""}})],1),_c('img',{staticClass:"home__background",attrs:{"src":_vm.bgStep}})])}
var staticRenderFns = []

export { render, staticRenderFns }